module.exports = __webpack_public_path__ + "img/logo-kermanmotor-w.59a16f6.svg";